import { render, staticRenderFns } from "./CraftingList.vue?vue&type=template&id=48c5acdf&scoped=true"
import script from "./CraftingList.vue?vue&type=script&lang=js"
export * from "./CraftingList.vue?vue&type=script&lang=js"
import style0 from "./CraftingList.vue?vue&type=style&index=0&id=48c5acdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c5acdf",
  null
  
)

export default component.exports